<section class="content">
    <div class="error-page">
        <h2 class="headline text-warning">404</h2>

        <div class="error-content">
            <h3>
                <i class="fas fa-exclamation-triangle text-warning"></i>
                Pagina no encontrada
            </h3>

            <p>
                No pudimos encontrar esta pagina, Mientras tanto puede ir a
                <a href="../seguridad/login/login">
                    Pagina de inicio de sesion
                </a>
                .
            </p>
        </div>
    </div>
</section>
